<onyx-section [heading]="`${I18N}.heading`">
  <form [formGroup]="form()" [onyxAutoFocus]="mode()">
    @let controls = form().controls;
    <onyx-text-field
      data-testid="registration-number-field"
      [formControl]="controls.registrationNumber"
      label="labels.registrationNumber"
      [textTransform]="['uppercase', 'remove-whitespaces']"
      [size]="32"
    ></onyx-text-field>

    <onyx-text-field
      data-testid="side-number-field"
      [formControl]="controls.sideNumber"
      label="labels.sideNumber"
      [size]="32"
    ></onyx-text-field>

    <onyx-text-field
      data-testid="vin-number-field"
      class="vin-number"
      [formControl]="controls.vinNumber"
      label="labels.vinNumber"
      textTransform="uppercase"
      [size]="32"
    ></onyx-text-field>

    <onyx-form-group class="break" [controls]="controls.make">
      <onyx-dropdown
        data-testid="make-dropdown"
        [formControl]="controls.make"
        label="labels.make"
        [options]="makes$ | async"
        [search]="true"
        [showErrors]="false"
        [size]="32"
      ></onyx-dropdown>

      <onyx-suggestions
        [control]="controls.make"
        [suggestions]="makeSuggestions()"
      ></onyx-suggestions>
    </onyx-form-group>

    <onyx-text-field
      data-testid="model-field"
      [formControl]="controls.model"
      label="labels.model"
      [size]="32"
    ></onyx-text-field>

    <onyx-form-group [controls]="controls.manufactureYear">
      <onyx-text-field
        data-testid="manufacture-year-field"
        [formControl]="controls.manufactureYear"
        label="labels.manufactureYear"
        placeholder="placeholders.year"
        [decimalPlaces]="0"
        [showErrors]="false"
        [size]="32"
      ></onyx-text-field>

      <onyx-suggestions
        [control]="controls.manufactureYear"
        [suggestions]="MANUFACTURE_YEAR_SUGGESTIONS"
      ></onyx-suggestions>
    </onyx-form-group>

    <onyx-datepicker
      data-testid="first-registration-date-datepicker"
      [formControl]="controls.firstRegistrationDate"
      label="labels.firstRegistrationDate"
      [yearsRange]="{ past: 50, future: 0 }"
      [size]="32"
    ></onyx-datepicker>

    <onyx-dropdown
      data-testid="registration-country-dropdown"
      [formControl]="controls.registrationCountry"
      label="labels.registrationCountry"
      [options]="countries$ | async"
      [search]="true"
      [size]="32"
    ></onyx-dropdown>

    <onyx-dropdown
      data-testid="state-dropdown"
      [formControl]="controls.state"
      label="labels.state"
      [options]="states$ | async"
      [hint]="stateHintTemplate"
      [size]="32"
    ></onyx-dropdown>

    @if (controls.planningMode.enabled) {
      <onyx-dropdown
        data-testid="planning-mode-dropdown"
        [formControl]="controls.planningMode"
        label="labels.planning"
        [options]="planningModes$ | async"
        [size]="32"
      ></onyx-dropdown>
    }

    @if (controls.initialMileage.enabled) {
      <onyx-text-field
        data-testid="initial-mileage-field"
        [formControl]="controls.initialMileage"
        label="labels.initialMileage"
        [decimalPlaces]="0"
        unit="km"
        [size]="32"
      ></onyx-text-field>
    }

    @if (controls.maxSpeed.enabled) {
      <onyx-form-group [controls]="controls.maxSpeed">
        <onyx-text-field
          data-testid="max-speed-field"
          [formControl]="controls.maxSpeed"
          label="labels.maxSpeed"
          [decimalPlaces]="0"
          unit="km/h"
          [size]="32"
        ></onyx-text-field>

        <onyx-suggestions
          [control]="controls.maxSpeed"
          [suggestions]="MAX_SPEED_SUGGESTIONS"
        ></onyx-suggestions>
      </onyx-form-group>
    }

    @if (controls.assignedBase.enabled) {
      <onyx-form-group [controls]="controls.assignedBase">
        <onyx-dropdown
          data-testid="assigned-base-dropdown"
          [formControl]="controls.assignedBase"
          label="labels.base"
          [link]="baseDropdownActions.link()"
          [options]="BASES_SOURCE"
          [optional]="true"
          [showErrors]="false"
          [search]="true"
          [showAddOption]="baseDropdownActions.hasAdd()"
          [size]="32"
          (addOption)="baseDropdownActions.add()"
        ></onyx-dropdown>

        <onyx-suggestions
          [control]="controls.assignedBase"
          [suggestions]="baseSuggestions$ | async"
        ></onyx-suggestions>
      </onyx-form-group>
    }
  </form>
</onyx-section>

<ng-template #stateHintTemplate>
  <p [innerHTML]="`${I18N}.stateHint` | translate"></p>
</ng-template>
